// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-vfe9hvuwwwbpnea5e7h1m239c39vaxxavpnbqjb4czdwbnh3y53nscxzjyvzbnxaxj68hr49z7tn7v3uemjmww1qku8yb5cnm5f6rw","IFrame":"IFrame-41az8pq25pf6k91vyu8aydvkn5b2mv9wuk5qe4mkp1xvzfuhswkzwv5xgcefkn1a9wpnws5a4u7wkrv1gpw468rt6nk5dgun5pbyttg","loading":"loading-3kz841kvnpktf1y45sbpaedfqmt3s6a27zar9grn3kf3u4vn4afygex63wrew7sfkvbqsf2h2bg92prsrgfpd8xr7xy1wkb2dc531s2","pulse":"pulse-2jnystfm8bpgr93muqc8f64xrxr6fsvzh95xb1xckg5x99drxjsu4yypqht41x9n43srkc3q4xjf6zbsbwpe52dkwtuk2xedgxbdh1w"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/VideoSection/VideoSection.module.scss
// module id = 1707
// module chunks = 0